import { AuthCubit } from "../../blocs/auth/AuthBloc";
import { AuthState } from "../../blocs/auth/authStates";
import useCubit from "../../blocs/hooks";
import { UserRight, hasRight } from "../../core/models/User";
import YouShallNotPass from "../YouShallNotPass";
import { AdminDashboard } from "./AdminDashboard";

export default function Admin() {
    const authCubit = AuthCubit.getInstance();
    const authState: AuthState = useCubit(authCubit);

    return <>
        {(authState.state !== 'LOGGEDIN') && (<YouShallNotPass />)}
        {(authState.state === 'LOGGEDIN' && hasRight(UserRight.canSeeAdminPanel, authState.user!)) && (<AdminDashboard />)}
    </>;
}